'use client';
import { useContext } from 'react';

function useNonNullishContext(r, t) {
    let e = useContext(r);
    if (null == e) throw Error(null != t ? t : `Context:${r.displayName} is null Or undefined`);
    return e;
}

export { useNonNullishContext };
